import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import isFQDN from 'validator/es/lib/isFQDN';

@Directive({
  selector: '[appDomain]',
  providers: [{ provide: NG_VALIDATORS, useExisting: AppDomainValidator, multi: true }]
})
export class AppDomainValidator implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return control.value && !isFQDN(control.value) ? { domain: true } : null;
  }
}
